<template>
    <div>
        <div style="display:flex;justify-content: start;margin-top: 5px;font-size:15px; color: black;">
            Input Details on Inventory
            </div>
            
        <div style="margin-top: 30px;margin-bottom:30px">
            <a-spin :spinning="loading">
                <a-form-model 
                ref="addInputInventoryDetailsForm"
                :model="addInputInventoryDetails"
                :rules="rules" 
                >
                    <a-row type="flex" justify="start">
                        <a-col :span="21" :offset="0">
                            <a-form-model-item label="Will you like to Prestock this product at our Fufillment Center?" ref="prestock" prop="prestock">
                                <a-select @change="onPrestockChange" class="dropdownItem"  v-model="addInputInventoryDetails.prestock" placeholder="please select your choice">
                                    <a-select-option value="true">
                                    Yes
                                    </a-select-option>
                                    <a-select-option value="false">
                                    No
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="showPrestock" type="flex" justify="start">
                        <a-col :span="21" :offset="0">
                             <a-form-model-item label="How many units will you like to send?" ref="prestockQuantity" prop="prestockQuantity">
                                 <div style="display:flex;justify-content: space-between;">
                                     <a-input 
                                        class="numberInput"
                                        v-model="addInputInventoryDetails.prestockQuantity"
                                    />
                                    <span style="background:#ccc;line-height:2.1;margin-left:5px;padding-left:5px;padding-right:5px;border-radius:5px">Unit(s)</span>
                                 </div>
                                     
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="showPrestock" type="flex" justify="start">
                         <a-col :span="21" :offset="0">
                            <a-form-model-item label="How often do you want to replenish the available stock at Fulfillment Center?" ref="prestockFrequency" prop="prestockFrequency">
                                <a-select class="dropdownItem"  v-model="addInputInventoryDetails.prestockFrequency" placeholder="please select your choice">
                                    <a-select-option value="0">
                                    Weekly
                                    </a-select-option>
                                    <a-select-option value="1">
                                    Monthly
                                    </a-select-option>
                                    <a-select-option value="2">
                                    Quarterly
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row type="flex" justify="start">
                        <a-col :span="21" :offset="0">
                            <a-form-model-item label="Will you like to take Pre-Order for this product?" ref="prestockOrder" prop="prestockOrder">
                                <a-select @change="onPrestockOrderChange" class="dropdownItem" v-model="addInputInventoryDetails.prestockOrder" placeholder="please select your choice">
                                    <a-select-option value="true">
                                    Yes
                                    </a-select-option>
                                    <a-select-option value="false">
                                    No
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                     <a-row v-if="showPrestockOrder" type="flex" justify="start" >
                         <a-col :span="20">
                             <a-form-model-item label="What maximum unit should we to take preorders for this product?" ref="maxQuantity" prop="maxQuantity">
                                 <div style="display:flex;justify-content: space-between;">
                                     <a-input
                                    class="dropdownItem"
                                        v-model="addInputInventoryDetails.maxQuantity"
                                    />
                                    <span style="background:#ccc;line-height:2.1;margin-left:5px;padding-left:5px;padding-right:5px;border-radius:5px">Units(s)</span>
                                 </div>
                            </a-form-model-item>
                         </a-col>
                         
                     </a-row>
                     <a-row v-if="showPrestockOrder" type="flex" justify="start">
                         <a-col :span="20" >
                             <a-form-model-item label="When a pre-order is taken for this product, how soon can you ship?" ref="fulfillmentLatency" prop="fulfillmentLatency">
                                <div style="display:flex;justify-content: space-between;">
                                    <a-input-number
                                    class="dropdownItem"
                                    v-model="addInputInventoryDetails.fulfillmentLatency"
                                    :min="1" :max="14"
                                    />
                                    <span style="background:#ccc;line-height:2.1;margin-left:5px;padding-left:5px;padding-right:5px;border-radius:5px">Day(s)</span>
                                </div>
                            </a-form-model-item>
                            <small style="color:red">Maximun is 14 days</small>
                            
                         </a-col>
                     </a-row>
                
                </a-form-model>

                <div style="display:flex;justify-content: start;">
                    <a-button @click="saveProductInventoryynfo" style="background: #418a49;color:#fff;">
                        Submit
                    </a-button>
                </div>
            </a-spin>
            
        </div>
    </div>
</template>

<script>
import { mapActions , mapGetters} from 'vuex';
    export default {
        name:"AddInventoryDetails",
        data(){
            return {
                loading:false,
                addInputInventoryDetails:{
                    prestock:"",
                    prestockFrequency:"",
                    prestockQuantity:"",
                    prestockOrder:"",
                    fulfillmentLatency:"",
                    maxQuantity:"",
                    productDetails:{}
                },
                showPrestock: false,
                showPrestockOrder: false,
                rules: {
                     prestock: [
                        { required: true, message: 'Please choose your choice', trigger: 'change' }
                    ],
                    prestockOrder: [
                        { required: true, message: 'Please choose your choice', trigger: 'change' }
                    ],
                    prestockFrequency: [
                        { required: true, message: 'Please select prestock frequency', trigger: 'change' },
                    ],
                    prestockQuantity: [
                        { required: true, message: 'Please enter prestock quantity', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/), 
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                    ],
                    fulfillmentLatency: [
                        { required: true, message: 'Please enter fulfillment latency', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),  
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                        
                    ],
                    maxQuantity: [
                        { required: true, message: 'Please enter max quantity', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),  
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                    ],
                    
                },
            }
        },
        computed: mapGetters(['getProductDetailsInfo']),
        methods:{
            ...mapActions(['setStepCount','addProductInventory','resetAddProductSetup']),
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            onPrestockChange(value){
                // console.log("value | ", value)
                if(value === "true"){
                    this.showPrestock = true;
                }else{
                    this.showPrestock = false;
                }
            },
            onPrestockOrderChange(value){
                // console.log("value | ", value)
                if(value === "true"){
                    this.showPrestockOrder = true;
                }else{
                    this.showPrestockOrder = false;
                }
            },
            saveProductInventoryynfo(){
                this.$refs.addInputInventoryDetailsForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let request_data = {
                            ProductId: this.productDetails.productId,
                            data: {
                                isPrestocked: this.addInputInventoryDetails.prestock === "true" ? true : false ,
                                prestockQuantity: this.addInputInventoryDetails.prestockQuantity === "" ? 0 : parseInt(this.addInputInventoryDetails.prestockQuantity),
                                prestockFrequency: this.addInputInventoryDetails.prestockFrequency === "" ? 0 : parseInt(this.addInputInventoryDetails.prestockFrequency),
                                isPreordered: this.addInputInventoryDetails.prestockOrder === "true" ? true : false,
                                fulfilmentLatency: this.addInputInventoryDetails.fulfillmentLatency === "" ? 0 : parseInt(this.addInputInventoryDetails.fulfillmentLatency),
                                maximumPreorderedQuantity: this.addInputInventoryDetails.maxQuantity === "" ? 0 : parseInt(this.addInputInventoryDetails.maxQuantity )
                            }
                        }

                        // console.log("request_data | ", request_data)
                        // this.setStepCount(0)
                        // this.showSuccessAlert("Product Inventory Added Successfully");
                        // this.$router.push(`/inventory`).catch(()=>{});

                        this.addProductInventory(request_data).then(response => {
                            this.loading = false
                            if(response.status == 200){
                                this.showSuccessAlert("Product Inventory Added Successfully")
                                this.setStepCount(0)
                                this.resetAddProductSetup()
                                window.location.reload();
                                // this.$router.push(`/inventory`).catch(()=>{});
                            }else{
                                this.loading = false
                                // console.log("Error | ", response)
                            }
                        }, error => {
                            this.loading = false
                            console.log("Error | " , error)
                        });
                        
                    }else{
                        return false
                    }
                })
            }
        },
        created(){
            if(this.getProductDetailsInfo){
                this.productDetails = this.getProductDetailsInfo
            }
        }
    }
</script>

<style scoped>

.img_size{
    max-width: 56px;
    max-height: 55px;
}
.dropdownItem{
    width: 100%;
    border-radius: 5px;
}
.numberInput{
    width: 100%;
    border-radius: 5px;
}
</style>